<template>
  <Dialog
    v-model="dialogVisible"
    :title="isEditMode ? 'Edit Allergy' : 'Add Allergy'"
    dialog-type="primary"
    dialog-size="small"
    header-icon-width="28px"
    header-icon-height="17px"
    :close-on-overlay="false"
    @close="closeDialog"
  >
    <template #header-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="17" viewBox="0 0 28 17" fill="none">
        <path d="M14 17C13.1133 17 12.2558 16.876 11.4275 16.6281C10.5992 16.3802 9.835 16.0201 9.135 15.5479C8.10833 15.4771 7.05833 15.2528 5.985 14.875C4.91167 14.4972 3.93167 13.8715 3.045 12.9979C2.15833 12.1243 1.42917 10.9792 0.8575 9.5625C0.285833 8.14583 0 6.375 0 4.25V3.54167C0 2.55 0.338333 1.71181 1.015 1.02708C1.69167 0.342361 2.52 0 3.5 0C4.41 0 5.1975 0.31875 5.8625 0.95625C6.5275 1.59375 6.895 2.36111 6.965 3.25833C7.61833 3.06944 8.20167 2.83333 8.715 2.55C9.22833 2.26667 9.75333 1.99514 10.29 1.73542C10.8267 1.45208 11.3867 1.21007 11.97 1.00937C12.5533 0.808681 13.23 0.708333 14 0.708333C14.7933 0.708333 15.4758 0.808681 16.0475 1.00937C16.6192 1.21007 17.1733 1.45208 17.71 1.73542C18.2233 1.99514 18.7425 2.26667 19.2675 2.55C19.7925 2.83333 20.3817 3.06944 21.035 3.25833C21.105 2.3375 21.4725 1.56424 22.1375 0.938542C22.8025 0.312847 23.59 0 24.5 0C25.48 0 26.3083 0.342361 26.985 1.02708C27.6617 1.71181 28 2.55 28 3.54167V4.25C28 6.375 27.7142 8.14583 27.1425 9.5625C26.5708 10.9792 25.8417 12.1243 24.955 12.9979C24.0683 13.8715 23.0883 14.4972 22.015 14.875C20.9417 15.2528 19.8917 15.4771 18.865 15.5479C18.165 16.0201 17.4008 16.3802 16.5725 16.6281C15.7442 16.876 14.8867 17 14 17ZM6.3 12.7146C5.85667 12.0063 5.5125 11.233 5.2675 10.3948C5.0225 9.5566 4.9 8.68889 4.9 7.79167V3.54167C4.9 3.14028 4.76583 2.80382 4.4975 2.53229C4.22917 2.26076 3.89667 2.125 3.5 2.125C3.10333 2.125 2.77083 2.26076 2.5025 2.53229C2.23417 2.80382 2.1 3.14028 2.1 3.54167V4.25C2.1 6.84722 2.53167 8.78333 3.395 10.0583C4.25833 11.3333 5.22667 12.2188 6.3 12.7146ZM14 14.875C15.9367 14.875 17.5875 14.1844 18.9525 12.8031C20.3175 11.4219 21 9.75139 21 7.79167V5.45417C20.2067 5.26528 19.5125 5.04097 18.9175 4.78125C18.3225 4.52153 17.78 4.23819 17.29 3.93125C16.6367 3.52986 16.0592 3.24653 15.5575 3.08125C15.0558 2.91597 14.5367 2.83333 14 2.83333C13.4633 2.83333 12.9442 2.91597 12.4425 3.08125C11.9408 3.24653 11.3633 3.52986 10.71 3.93125C10.22 4.21458 9.6775 4.49792 9.0825 4.78125C8.4875 5.06458 7.79333 5.28889 7 5.45417V7.79167C7 9.75139 7.6825 11.4219 9.0475 12.8031C10.4125 14.1844 12.0633 14.875 14 14.875ZM9.8 7.4375C10.3133 7.29583 10.7567 7.12465 11.13 6.92396C11.5033 6.72326 11.8533 6.52847 12.18 6.33958C12.5067 6.15069 12.8042 5.99132 13.0725 5.86146C13.3408 5.7316 13.65 5.66667 14 5.66667C14.35 5.66667 14.6592 5.7316 14.9275 5.86146C15.1958 5.99132 15.4933 6.15069 15.82 6.33958C16.1467 6.52847 16.4908 6.72326 16.8525 6.92396C17.2142 7.12465 17.6633 7.29583 18.2 7.4375V5.95C17.85 5.83194 17.5467 5.70208 17.29 5.56042L16.52 5.13542C16.1467 4.89931 15.7675 4.69271 15.3825 4.51562C14.9975 4.33854 14.5367 4.25 14 4.25C13.4633 4.25 13.0025 4.33854 12.6175 4.51562C12.2325 4.69271 11.8417 4.89931 11.445 5.13542L10.675 5.56042C10.4183 5.70208 10.1267 5.83194 9.8 5.95V7.4375ZM21.7 12.7146C22.7733 12.2188 23.7417 11.3333 24.605 10.0583C25.4683 8.78333 25.9 6.84722 25.9 4.25V3.54167C25.9 3.14028 25.7658 2.80382 25.4975 2.53229C25.2292 2.26076 24.8967 2.125 24.5 2.125C24.1033 2.125 23.7708 2.26076 23.5025 2.53229C23.2342 2.80382 23.1 3.14028 23.1 3.54167V7.79167C23.1 8.68889 22.9833 9.5566 22.75 10.3948C22.5167 11.233 22.1667 12.0063 21.7 12.7146Z" fill="white"/>
      </svg>
    </template>

    <div class="allergy-form-body">
      <!-- Form Fields -->
      <div class="form-fields">
        <!-- Two Column Row: Allergen & Severity -->
        <div class="form-grid">
          <!-- Allergen -->
          <div class="form-field">
            <label class="field-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="label-icon">
                <path d="M14 7C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7Z" fill="#374957"/>
                <path d="M13.8 11.48L14 11.5C14.83 11.5 15.5 10.83 15.5 10C15.5 9.17 14.83 8.5 14 8.5C13.17 8.5 12.5 9.17 12.5 10L12.52 10.2C12.61 10.87 13.13 11.39 13.8 11.48ZM14 3.5C14.28 3.5 14.5 3.28 14.5 3C14.5 2.72 14.28 2.5 14 2.5C13.72 2.5 13.5 2.72 13.5 3C13.5 3.28 13.72 3.5 14 3.5ZM10 3.5C10.28 3.5 10.5 3.28 10.5 3C10.5 2.72 10.28 2.5 10 2.5C9.72 2.5 9.5 2.72 9.5 3C9.5 3.28 9.72 3.5 10 3.5Z" fill="#374957"/>
                <path d="M18 11C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9C17.4477 9 17 9.44772 17 10C17 10.5523 17.4477 11 18 11Z" fill="#374957"/>
                <path d="M18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7Z" fill="#374957"/>
                <path d="M21 10.5C21.28 10.5 21.5 10.28 21.5 10C21.5 9.72 21.28 9.5 21 9.5C20.72 9.5 20.5 9.72 20.5 10C20.5 10.28 20.72 10.5 21 10.5Z" fill="#374957"/>
                <path d="M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z" fill="#374957"/>
                <path d="M18 15C18.5523 15 19 14.5523 19 14C19 13.4477 18.5523 13 18 13C17.4477 13 17 13.4477 17 14C17 14.5523 17.4477 15 18 15Z" fill="#374957"/>
                <path d="M6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z" fill="#374957"/>
                <path d="M14 20.5C13.72 20.5 13.5 20.72 13.5 21C13.5 21.28 13.72 21.5 14 21.5C14.28 21.5 14.5 21.28 14.5 21C14.5 20.72 14.28 20.5 14 20.5ZM21 13.5C20.72 13.5 20.5 13.72 20.5 14C20.5 14.28 20.72 14.5 21 14.5C21.28 14.5 21.5 14.28 21.5 14C21.5 13.72 21.28 13.5 21 13.5ZM3 13.5C2.72 13.5 2.5 13.72 2.5 14C2.5 14.28 2.72 14.5 3 14.5C3.28 14.5 3.5 14.28 3.5 14C3.5 13.72 3.28 13.5 3 13.5Z" fill="#374957"/>
                <path d="M10 19C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17C9.44772 17 9 17.4477 9 18C9 18.5523 9.44772 19 10 19Z" fill="#374957"/>
                <path d="M3 9.5C2.72 9.5 2.5 9.72 2.5 10C2.5 10.28 2.72 10.5 3 10.5C3.28 10.5 3.5 10.28 3.5 10C3.5 9.72 3.28 9.5 3 9.5ZM10 20.5C9.72 20.5 9.5 20.72 9.5 21C9.5 21.28 9.72 21.5 10 21.5C10.28 21.5 10.5 21.28 10.5 21C10.5 20.72 10.28 20.5 10 20.5Z" fill="#374957"/>
                <path d="M6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z" fill="#374957"/>
                <path d="M2.5 5.27L6.28 9.05L6 9C5.45 9 5 9.45 5 10C5 10.55 5.45 11 6 11C6.55 11 7 10.55 7 10C7 9.9 6.97 9.81 6.94 9.72L9.75 12.53C9.04 12.64 8.5 13.26 8.5 14C8.5 14.83 9.17 15.5 10 15.5C10.74 15.5 11.36 14.96 11.47 14.25L14.28 17.06C14.19 17.03 14.1 17 14 17C13.45 17 13 17.45 13 18C13 18.55 13.45 19 14 19C14.55 19 15 18.55 15 18C15 17.9 14.97 17.81 14.94 17.72L18.72 21.5H18.73L20.14 20.09L3.91 3.86L2.5 5.27Z" fill="#374957"/>
              </svg>
              Allergen <span class="required-text">(Required)</span>
            </label>
            <TextInput
              v-model="formData.allergen"
              size="medium"
              :clearable="false"
              placeholder="Input Allergen"
            />
          </div>

          <!-- Severity -->
          <div class="form-field">
            <label class="field-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="label-icon">
                <path d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18 6H13.58V9.33H11V12.66H8.42V16H6V18H10.42V14.67H13V11.34H15.58V8H18V6Z" fill="#374957"/>
              </svg>
              Severity
            </label>
            <SingleSelector
              v-model="formData.severity"
              placeholder="Select Severity"
              :options="severityOptions"
              size="medium"
            />
          </div>
        </div>

        <!-- Reactions -->
        <div class="form-field reactions-field">
          <label class="field-label">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="label-icon">
              <path d="M6.72984 10.56L7.78984 9.5L6.72984 8.44L7.78984 7.38L9.90984 9.5L7.78984 11.62L6.72984 10.56ZM3.90984 9C3.93984 9 3.95984 9.01 3.98984 9.01C5.17984 6.07 8.04984 4 11.4098 4C13.5998 4 15.5698 4.88 17.0198 6.3C17.1698 5.7 17.4698 5.01 17.8298 4.34C16.0898 2.88 13.8498 2 11.3998 2C6.51984 2 2.45984 5.51 1.58984 10.14C2.14984 9.44 2.99984 9 3.90984 9ZM20.4098 10.5C19.9898 10.5 19.5898 10.41 19.2198 10.28C19.3398 10.83 19.4098 11.41 19.4098 12C19.4098 16.42 15.8298 20 11.4098 20C8.04984 20 5.17984 17.93 3.98984 14.99C3.95984 14.99 3.93984 15 3.90984 15C3.38984 15 2.86984 14.86 2.40984 14.6C2.08984 14.42 1.81984 14.18 1.58984 13.9C2.47984 18.51 6.51984 22 11.3898 22C16.9298 22 21.4098 17.52 21.4098 12C21.4098 11.45 21.3498 10.91 21.2698 10.38C20.9898 10.45 20.7098 10.5 20.4098 10.5ZM20.4098 3C20.4098 3 18.4098 5.9 18.4098 7C18.4098 8.1 19.3098 9 20.4098 9C21.5098 9 22.4098 8.1 22.4098 7C22.4098 5.9 20.4098 3 20.4098 3ZM15.0298 7.38L12.9098 9.5L15.0298 11.62L16.0898 10.56L15.0298 9.5L16.0898 8.44L15.0298 7.38ZM7.96984 17C8.65984 15.81 9.93984 15 11.4098 15C12.8798 15 14.1598 15.81 14.8498 17H16.5298C15.7298 14.95 13.7398 13.5 11.4098 13.5C10.5398 13.5 9.70984 13.7 8.97984 14.07L5.39984 12C5.39984 11.48 5.13984 10.98 4.65984 10.71C3.93984 10.3 3.02984 10.54 2.60984 11.26C2.19984 11.98 2.43984 12.89 3.15984 13.31C3.63984 13.59 4.20984 13.56 4.64984 13.31L7.61984 15.03C7.04984 15.56 6.58984 16.24 6.28984 17H7.96984Z" fill="#374957"/>
            </svg>
            Reactions
          </label>
          <TextArea
            v-model="formData.reactions"
            placeholder="Describe reactions, e.g., Anaphylaxis"
            :max_length="1000"
            :rows="3"
          />
        </div>
      </div>
    </div>

    <!-- Dialog Footer -->
    <template #footer>
      <ResponsiveButton
        display_name="Cancel"
        button_type="outlined"
        built_in_theme="error"
        size="medium"
        @click-button="closeDialog"
      />
      <ResponsiveButton
        display_name="Save"
        button_type="filled"
        built_in_theme="dark"
        size="medium"
        :disabled="!isFormValid"
        @click-button="saveAllergy"
      />
    </template>
  </Dialog>
</template>

<script>
import { addAllergyRecord, updateAllergyRecord } from '@/api/medicationApi';
import { notify } from '@/utils/notify';

export default {
  name: 'AllergyFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    patientInfo: {
      type: Object,
      default: () => ({})
    },
    allergy: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        allergen: '',
        severity: '',
        reactions: ''
      },
      severityOptions: [
        { label: 'Mild', value: 'mild' },
        { label: 'Moderate', value: 'moderate' },
        { label: 'Severe', value: 'severe' }
      ]
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    },
    isEditMode() {
      return this.allergy !== null;
    },
    isFormValid() {
      return this.formData.allergen;
    }
  },
  watch: {
    allergy: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.formData = {
            allergen: newVal.allergen || '',
            severity: newVal.severity || '',
            reactions: newVal.reactions || ''
          };
        } else {
          this.resetForm();
        }
      }
    },
    visible(newVal) {
      if (newVal && !this.isEditMode) {
        this.resetForm();
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    async saveAllergy() {
      if (!this.isFormValid) return;

      const patientId = this.patientInfo?.patientBasicInfo?.patientId ||
                        this.patientInfo?.patientId ||
                        this.patientInfo?.id ||
                        this.patientInfo?.patientBasicInfo?.id;

      if (!patientId) {
        notify({
          title: 'Error',
          message: 'Patient ID is required',
          type: 'error',
          duration: 3000
        });
        return;
      }

      try {
        if (this.isEditMode && this.allergy?.id) {
          const updateData = {
            allergen_name: this.formData.allergen,
            reactions: this.formData.reactions || '',
            overall_severity: this.formData.severity ? this.capitalizeFirst(this.formData.severity) : ''
          };

          await updateAllergyRecord(patientId, this.allergy.id, updateData);

          notify({
            title: 'Success',
            message: 'Allergy Updated Successfully',
            type: 'success',
            duration: 3000
          });

          this.$emit('save', {
            id: this.allergy.id,
            allergen: this.formData.allergen,
            severity: this.formData.severity,
            reactions: this.formData.reactions
          });
        } else {
          const allergyData = {
            allergen_name: this.formData.allergen,
            reactions: this.formData.reactions,
            overall_severity: this.capitalizeFirst(this.formData.severity)
          };

          await addAllergyRecord(patientId, allergyData);

          notify({
            title: 'Success',
            message: 'Allergy Added Successfully',
            type: 'success',
            duration: 3000
          });

          this.$emit('save', {
            allergen: this.formData.allergen,
            severity: this.formData.severity,
            reactions: this.formData.reactions
          });
        }

        this.resetForm();
        this.$emit('close');
      } catch (error) {
        console.error('Failed to save allergy:', error);
        notify({
          title: 'Error',
          message: this.isEditMode ? 'Failed to Update Allergy' : 'Failed to Save Allergy',
          type: 'error',
          duration: 3000
        });
      }
    },
    capitalizeFirst(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    resetForm() {
      this.formData = {
        allergen: '',
        severity: '',
        reactions: ''
      };
    }
  }
};
</script>

<style scoped>
.allergy-form-body {
  padding-top: 24px;
  padding-bottom: 8px;
}

/* Form fields layout */
.form-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Two column grid layout */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  overflow: hidden;
  color: var(--color-Grey-Grey-4A, #4A4A4A);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.label-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

/* Required text styling */
.required-text {
  color: #D10000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
}

/* Form inputs - consistent border #C4C4C4 */
:deep(.el-input .el-input__wrapper) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
}

:deep(.el-input .el-input__wrapper:hover),
:deep(.el-input .el-input__wrapper:focus),
:deep(.el-input .el-input__wrapper.is-focus) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
}

/* Select dropdown borders */
:deep(.new-libary-single-selector) {
  height: 40px;
}

:deep(.new-libary-single-selector .el-select__wrapper) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
  min-height: 40px !important;
}

:deep(.new-libary-single-selector .el-select__wrapper:hover),
:deep(.new-libary-single-selector .el-select__wrapper:focus),
:deep(.new-libary-single-selector .el-select__wrapper.is-focus) {
  border: 1px solid #C4C4C4 !important;
  box-shadow: none !important;
  height: 40px !important;
}

/* Placeholder color - gray (when nothing is selected) */
:deep(.new-libary-single-selector .el-select__wrapper.is-transparent) {
  color: #999 !important;
}

/* Selected value text color - black (when value is selected) */
:deep(.new-libary-single-selector .el-select__wrapper:not(.is-transparent)) {
  color: #000 !important;
}
</style>
